import { render, staticRenderFns } from "./CommonFooter.vue?vue&type=template&id=20f81374&scoped=true"
var script = {}
import style0 from "./CommonFooter.vue?vue&type=style&index=0&id=20f81374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f81374",
  null
  
)

export default component.exports